<template>
  <div v-if="!getCustomerLoading">
    <div class="col-grid-2 lcu-form-fieldWrap">
      <div>
          <div class="lcu-form-fieldWrap">
              <label class="lcu-section-label" for="paymentMethod">
                  Métodos de Pago
                  <button
                      type="button"
                      aria-label="edit payment method"
                      @click.prevent="toggleEdit('paymentMethod')"
                      :class="{
                          'lcu-cancel-btn': edit.paymentMethod
                      }"
                      class="lcu-edit-btn" />
              </label>
              <div v-if="!edit.paymentMethod">
                <p v-if="paymentMethods.length < 1">No hay métodos de pago guardados.</p>
                <div v-if="paymentMethods.length > 0" class="lcu-cards-container">
                  <div class="lcu-sub-card" v-if="paymentMethods.length > 1" />
                  <div class="lcu-main-card">
                    <div>
                      <img
                        class="lcu-card-logo"
                        :src="'/assets/' + getImg(displayCard.brand) + '.svg'" />
                    </div>
                    <div class="lcu-main-cardInfo">
                      <span>{{ displayCard.name }}</span>
                      <span>
                        Exp {{ displayCard.expMonth }} / {{ displayCard.expYear }}
                      </span>
                      <span>xxxx xxxx xxxx {{ displayCard.last4 }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="lcu-input-grid" v-if="edit.paymentMethod">
                <div class="row">
                  <div>
                    <button-cta
                        :text="!addNewPayment ? 'Agregar nuevo método de pago' : 'Cancelar'"
                        :loading="false"
                        border
                        @on-click="addNewPayment = !addNewPayment" />
                  </div>
                </div>
                <div class="row lcu-billing-newForm" v-if="addNewPayment">
                  <div class="lcu-section-label">
                    Nuevo Método de Pago
                  </div>
                  <div class="row row-large">
                    <div class="row row-small">
                      <form-field :id="'name'" :label="'Nombre en Tarjeta'" required>
                        <input
                          type="text"
                          id="name"
                          @input="validate(['name'])"
                          v-model="validations.name.value"
                          :class="{
                            'lcu-billing-inputError': validations.name.errors.length > 0
                          }"
                          class="lcu-billing-inputText" />
                      </form-field>
                    </div>
                    <div class="row row-small" v-if="validations.name.errors.length > 0">
                      <span class="lcu-billing-errorMsg">
                        {{ validations.name.errors.join(' ') }}
                      </span>
                    </div>
                  </div>
                  <div class="row row-large">
                    <div class="row row-small">
                      <form-field :id="'card-number'" :label="'Número de Tarjeta'" required>
                        <input
                          type="text"
                          id="card-number"
                          @input="validate(['cardNum'])"
                          autocomplete="cc-number"
                          placeholder="0000 0000 0000 0000"
                          v-maska="'#### #### #### ####'"
                          v-model="validations.cardNum.value"
                          :class="{
                            'lcu-billing-inputError': validations.cardNum.errors.length > 0
                          }"
                          class="lcu-billing-inputText" />
                      </form-field>
                    </div>
                    <div class="row row-small" v-if="validations.cardNum.errors.length > 0">
                      <span class="lcu-billing-errorMsg">
                        {{ validations.cardNum.errors.join(' ') }}
                      </span>
                    </div>
                  </div>
                  <div class="row row-large">
                    <div class="col-grid-2">
                      <div class="lcu-mobile-bump">
                        <div class="row row-small">
                          <form-field :id="'exp-date'" :label="'Fecha de Expiración'" required>
                            <input
                              type="text"
                              id="exp-date"
                              @input="validate(['expDate'])"
                              placeholder="00 / 00"
                              v-maska="'## / ##'"
                              v-model="validations.expDate.value"
                              :class="{
                                'lcu-billing-inputError': validations.expDate.errors.length > 0
                              }"
                              class="lcu-billing-inputText" />
                          </form-field>
                        </div>
                        <div class="row row-small" v-if="validations.expDate.errors.length > 0">
                          <span class="lcu-billing-errorMsg">
                            {{ validations.expDate.errors.join(' ') }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div class="row row-small">
                          <form-field :id="'cvv'" :label="'CVV'" required>
                            <input
                              type="text"
                              id="cvv"
                              @input="validate(['cvv'])"
                              placeholder="000"
                              v-maska="'###'"
                              v-model="validations.cvv.value"
                              :class="{
                                'lcu-billing-inputError': validations.cvv.errors.length > 0
                              }"
                              class="lcu-billing-inputText" />
                          </form-field>
                        </div>
                        <div class="row row-small" v-if="validations.cvv.errors.length > 0">
                          <span class="lcu-billing-errorMsg">
                            {{ validations.cvv.errors.join(' ') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row row-large">
                    <form-field
                      :id="'default-payment'"
                      :sideLabel="true"
                      :label="'Establecer como predeterminado'">
                      <input
                        type="checkbox"
                        name="default-payment"
                        id="default-payment"
                        v-model="makeDefaultPayment"
                        class="lcu-form-checkbox" />
                    </form-field>
                  </div>
                  <div class="lcu-buttons-container">
                    <button-cta
                      :text="'Guardar Nuevo Método'"
                      :loading="loaders.paymentMethod"
                      @on-click="saveNewPayment" />
                  </div>
                </div>
                <div class="row" v-if="!addNewPayment">
                  <div class="lcu-card-file" v-for="card in paymentMethods" :key="card.id">
                    <img
                      :src="'/assets/' + getImg(card.brand) + '.svg'"
                      class="lcu-modal-cardLogo"
                      alt="card logo" />
                    <span>xxxx {{ card.last4 }}</span>
                    <span>{{ card.expMonth }}/{{ card.expYear }}</span>
                    <span>{{ card.name }}</span>
                    <span v-if="card.id === defaultPaymentMethod">(predeterminado)</span>
                    <span v-else> </span>
                    <IconButton
                      :classes="['lcu-edit-btn']"
                      @on-click="onEditCardClick(card)"
                      :icon="'lcu-trash'" />
                  </div>
                </div>
              </div>
          </div>
      </div>
      <div />
    </div>
    <div class="lcu-form-fieldWrap">
        <label class="lcu-section-label">
            Próximos Pagos
        </label>
        <div class="lcu-billingTable-header">
          <span>Cobro</span>
          <span>Cantidad</span>
          <span>Estado</span>
          <span>Fecha de Vencimiento</span>
          <span>Pagar</span>
        </div>
        <div class="lcu-billingTable-row" v-if="upcoming.length < 1">
          <span>No upcoming payments.</span>
        </div>
        <div class="lcu-billingTable-body">
          <div
            v-for="charge in upcoming"
            :key="charge.id"
            class="lcu-billingTable-row">
            <span>{{ charge.description }}</span>
            <span>{{ charge.amount }} ({{ charge.currency }})</span>
            <span>
              <span
                class="lcu-bill-status"
                :class="{
                  'lcu-bill-pastdue': charge.isPastDue && !charge.paid,
                  'lcu-bill-paid': charge.paid
                }">
                {{ getInvoiceStatus(charge) }}
              </span>
            </span>
            <span>{{ charge.dueDate }}</span>
            <IconButton
              @on-click="openReceipt(charge)"
              :disabled="!charge.receipt_url"
              :icon="'lcu-dollar-box'" />
          </div>
        </div>
    </div>
    <div class="lcu-form-fieldWrap">
        <label class="lcu-section-label">
            Estados de cuenta de facturación
        </label>
        <div class="lcu-billingTable-header">
          <span>Cobro</span>
          <span>Cantidad</span>
          <span>Estado</span>
          <span>Fecha</span>
          <span>Recibo</span>
        </div>
        <div class="lcu-billingTable-row" v-if="charges.length < 1">
          <span>No se muestran cargos.</span>
        </div>
        <div class="lcu-billingTable-body">
          <div
            v-for="charge in charges"
            :key="charge.id"
            class="lcu-billingTable-row">
            <span>{{ charge.description }}</span>
            <span>{{ charge.amount }} ({{ charge.currency }})</span>
            <span>
              <span
                class="lcu-bill-status"
                :class="{
                  'lcu-bill-pastdue': charge.isPastDue,
                  'lcu-bill-paid': charge.paid
                }">
                {{ charge.isPastDue && !charge.paid ? 'past due' : charge.status }}
              </span>
            </span>
            <span>{{ charge.created }}</span>
            <IconButton
              @on-click="openReceipt(charge)"
              :disabled="!charge.receipt_url"
              :icon="'lcu-receipt'" />
          </div>
        </div>
    </div>
  </div>
  <div class="row row-center" v-if="getCustomerLoading">
    <spin-loader :size="'100px'" />
  </div>
  <Modal v-model="isConfirmEditOpen" :close="() => { isConfirmEditOpen = false; }">
    <div class="lcu-modal lcu-modal-medium">
      <div class="row row-center" v-if="editPaymentLoading">
        <spin-loader />
      </div>
      <div v-if="!editPaymentLoading">
        <div class="row">
          <div class="lcu-modal-header">
            Editar método de pago
          </div>
        </div>
        <div class="row">
          <div class="lcu-modal-card">
            <img
              :src="'/assets/' + getImg(activeCard.brand) + '.svg'"
              class="lcu-modal-cardLogo"
              alt="card logo" />
            <span>xxxx {{ activeCard.last4 }}</span>
            <span>{{ activeCard.expMonth }}/{{ activeCard.expYear }}</span>
            <span>{{ activeCard.name }}</span>
          </div>
        </div>
        <div class="row" v-if="activeCard.id !== this.defaultPaymentMethod">
          <form-field
            :id="'make-default'"
            :sideLabel="true"
            :label="'Establecer como predeterminado'">
            <input
              type="checkbox"
              name="make-default"
              id="make-default"
              v-model="defaultPayment"
              class="lcu-form-checkbox" />
          </form-field>
        </div>
        <div class="row" v-if="activeCard.id === this.defaultPaymentMethod">
          Este método de pago es el predeterminado para tu cuenta.
        </div>
        <div v-if="cardEditError" class="row">
          <span class="lcu-default-error">
            {{ cardEditError }}
          </span>
        </div>
        <confirm-slider
          :on-confirm="() => onDeletePaymentMethod()"
          :on-cancel="() => deleteConfirmation = false"
          :is-showing="deleteConfirmation" />
        <div class="lcu-buttons-container">
          <button-cta
            :text="'Cancelar'"
            :type="'light'"
            @click.prevent="isConfirmEditOpen = false"
           />
          <button-cta
            :text="'Borrar método de pago'"
            :loading="editPaymentLoading"
            :classes="['lcu-delete-btn']"
            @on-click="deleteConfirmation = !deleteConfirmation" />
          <button-cta
            v-if="activeCard.id !== this.defaultPaymentMethod"
            :text="SAVE_CHANGES_TEXT"
            :disabled="!defaultPayment"
            :loading="editPaymentLoading"
            @on-click="onSaveEditCard" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ButtonCta from 'ç/buttons/Cta.vue';
import IconButton from 'ç/buttons/Icon.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import FormField from 'ç/forms/inputs/Field.vue';
import ConfirmSlider from 'ç/confirm-slider/ConfirmSlider.vue';
import FormValidator from '@/mixins/Validator.vue';
import { NOTIFICATION_SUCCESS, NOTIFICATION_ERROR, SAVE_CHANGES_TEXT } from '@/globals/constants';

export default {
  name: 'billing-page',
  computed: {
    ...mapGetters(['user']),
    displayCard() {
      const defaultCard = this.paymentMethods.find(c => c.id === this.defaultPaymentMethod);
      if (defaultCard) {
        return defaultCard;
      }
      return this.paymentMethods[0] || {};
    },
  },
  mixins: [FormValidator],
  components: {
    ButtonCta,
    IconButton,
    SpinLoader,
    'form-field': FormField,
    'confirm-slider': ConfirmSlider,
  },
  data() {
    return {
      addNewPayment: false,
      isConfirmEditOpen: false,
      editPaymentLoading: false,
      defaultPayment: false,
      deleteConfirmation: false,
      SAVE_CHANGES_TEXT,
      validations: {
        cardNum: {
          value: '',
          required: true,
          errors: [],
        },
        expDate: {
          value: '',
          required: true,
          errors: [],
        },
        cvv: {
          value: '',
          required: true,
          errors: [],
        },
        name: {
          value: '',
          required: true,
          errors: [],
        },
      },
      edit: {
        paymentMethod: false,
      },
      values: {
        paymentMethod: false,
      },
      initials: {
        paymentMethod: false,
      },
      loaders: {
        paymentMethod: false,
      },
      paymentMethods: [],
      getCustomerLoading: false,
      makeDefaultPayment: true,
      defaultPaymentMethod: false,
      cardEditError: false,
      activeCard: {},
      charges: [],
      upcoming: [],
    };
  },
  created() {
    this.loadCustomerData();
  },
  methods: {
    async loadCustomerData() {
      this.getCustomerLoading = true;
      try {
        const account = await this.$students({ method: 'getCustomerBilling' });
        this.$log.info('Billing account: ', account);
        this.charges = [...account.charges.filter(invoice => invoice.status === 'paid')];
        this.upcoming = [
          ...account.charges
            .filter(invoice => invoice.status === 'open')
            .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate)),
        ];
        this.paymentMethods = account.paymentMethods;
        this.defaultPaymentMethod = account.defaultMethod;
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
      } finally {
        this.getCustomerLoading = false;
      }
    },
    toggleEdit(item) {
    // if editing but user hits cancel, reset to initial value & vice versa
      if (this.edit[item]) {
        this.values[item] = this.initials[item];
      } else {
        this.initials[item] = this.values[item];
      }
      this.edit[item] = !this.edit[item];
    },
    onEditCardClick(card) {
      this.isConfirmEditOpen = true;
      this.activeCard = card;
      this.defaultPayment = card.id === this.defaultPaymentMethod;
    },
    async onSaveEditCard() {
      this.cardEditError = false;
      if (!this.defaultPayment) {
        this.isConfirmEditOpen = false;
        return;
      }
      this.editPaymentLoading = true;
      try {
        await this.$students({
          method: 'editDefaultSource',
          payload: {
            defaultPayment: this.defaultPayment,
            card: {
              id: this.activeCard.id,
            },
          },
        });
        this.isConfirmEditOpen = false;
        this.defaultPaymentMethod = this.activeCard.id;
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Método de pago actualizado correctamente',
          type: 'success',
        });
      } catch (e) {
        this.$log.error(e.message || e);
        this.cardEditError = 'Hubo un problema al establecer esta tarjeta como predeterminada.';
      } finally {
        this.editPaymentLoading = false;
      }
    },
    resetCardInputs() {
      this.validations.cardNum.value = '';
      this.validations.expDate.value = '';
      this.validations.cvv.value = '';
      this.validations.name.value = '';
    },
    async saveNewPayment() {
      if (this.loaders.paymentMethod) {
        return;
      }
      try {
        const validation = this.validate([
          'cardNum',
          'expDate',
          'cvv',
          'name',
        ]);
        if (!validation.passed) {
          return;
        }
        this.loaders.paymentMethod = true;
        const {
          cardNum,
          expDate,
          cvv,
          name,
        } = this.validations;
        const { card } = await this.$students({
          method: 'addPaymentMethod',
          payload: {
            makeDefaultPayment: this.makeDefaultPayment,
            card: {
              number: cardNum.value,
              cvc: cvv.value,
              name: name.value,
              expDate: expDate.value,
            },
          },
        });
        if (this.makeDefaultPayment) {
          this.defaultPaymentMethod = card.id;
        }
        this.$log.info('New card added: ', card);
        this.paymentMethods.push(card);
        this.edit.paymentMethod = false;
        this.addNewPayment = false;
        this.resetCardInputs();
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Nuevo método de pago guardado correctamente',
          type: 'success',
        });
      } catch (e) {
        this.$log.error(e.message || e);
        this.$notify({
          title: NOTIFICATION_ERROR,
          text: 'Hubo un problema con la información de tu tarjeta. Por favor, verifíquela e intente de nuevo.',
          type: 'error',
          duration: -1,
        });
      } finally {
        this.loaders.paymentMethod = false;
      }
    },
    getInvoiceStatus(charge) {
      if (charge.isPastDue && !charge.paid) {
        return 'past due';
      }
      if (charge.status === 'open') {
        return 'unpaid';
      }
      return charge.status;
    },
    async onDeletePaymentMethod() {
      this.deleteConfirmation = false;
      this.editPaymentLoading = true;
      try {
        await this.$students({
          method: 'deletePaymentMethod',
          payload: {
            cardId: this.activeCard.id,
          },
        });
        this.isConfirmEditOpen = false;
        if (this.defaultPaymentMethod === this.activeCard.id) {
          this.defaultPaymentMethod = false;
        }
        const index = this.paymentMethods.findIndex(c => c.id === this.activeCard.id);
        if (index > -1) {
          this.paymentMethods.splice(index, 1);
        }
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Método de pago eliminado correctamente',
          type: 'success',
        });
      } catch (e) {
        this.$log.error(e.message || e);
        this.cardEditError = 'Hubo un problema al eliminar este método de pago.';
      } finally {
        this.editPaymentLoading = false;
      }
    },
    openReceipt(charge) {
      if (charge.receipt_url) {
        window.open(charge.receipt_url, '_blank', 'noopener,noreferrer');
      }
    },
    getImg(brand) {
      const type = brand.replace(/ /, '-');
      const cards = {
        amex: 'amex',
        visa: 'visa',
        mastercard: 'mastercard',
        discover: 'discover',
        'american-express': 'american-express',
      };
      return cards[type] || 'default';
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-cards-container {
  position: relative;
}

.lcu-main-card {
  background-color: $white;
  border: 2px solid $legacy-primary;
  height: 150px;
  width: 250px;
  border-radius: 8px;
  padding: 15px;
  position: relative;
  z-index: 4;
  display: flex;
  flex-direction: column;
}

.lcu-sub-card {
  z-index: 3;
  background-color: $gray;
  border: 2px solid $legacy-primary;
  height: 150px;
  width: 250px;
  border-radius: 8px;
  top: 5px;
  left: 5px;
  position: absolute;
}

.lcu-main-cardInfo {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
  height: 100%;
}

.lcu-card-file {
  display: grid;
  grid-template-columns: max-content max-content max-content 1fr max-content 30px;
  grid-gap: 25px;
  border: 1px solid $page-border;
  border-radius: 3px;
  padding: 10px;
  align-items: center;
  margin-bottom: 3px;

  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-billingTable-header {
  display: grid;
  grid-template-columns: 1fr 15% 10% 15% 5%;
  grid-gap: 25px;
  background-color: $off-white;
  padding: 12px 10px;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr 15% 10% 15% 15%;
  }
}

.lcu-billingTable-body {
  max-height: 350px;
  overflow: scroll;
}

.lcu-billingTable-row {
  display: grid;
  grid-template-columns: 1fr 15% 10% 15% 5%;
  grid-gap: 25px;
  padding: 12px 10px;
  border-bottom: 1px solid $off-white;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr 15% 10% 15% 15%;
  }

  &:last-child {
    border-bottom: 0;
  }
}

.lcu-form-checkbox {
  background-color: rgba($black, .05);

  &:checked {
    background-color: $legacy-primary;
  }
}

.lcu-buttons-container {
  display: flex;
  justify-content: flex-end;

  & > button {
    margin-left: 5px;
  }
}

.lcu-delete-btn {
  background-color: $danger;
}

.lcu-billing-inputText {
  background-color: transparent;
  border: 0;
  border-bottom: 2px solid $legacy-primary;
  color: $legacy-primary;
  font-size: 16px;
  padding: 5px;
  width: 100%;

  &:focus-visible {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus-within {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }
}

.lcu-billing-errorMsg {
  color: $danger;
  display: inline-block;
  font-size: 16px;
}

.lcu-billing-inputError {
  background-color: #ffe6e6;
  border-color: $danger;

  &:focus-visible {
    border-color: $danger;
  }

  &:focus {
    border-color: $danger;
  }

  &:focus-within {
    border-color: $danger;
  }
}

.lcu-billing-newForm {
  padding: 20px;
  border: 1px solid $page-border;
  border-radius: 5px;
  background-color: #f6f6f6;
}

.lcu-mobile-bump {

  @media only screen and (max-width: $mobile-max) {
    margin-bottom: 25px;
  }
}

.lcu-card-logo {
  width: 20%;
}

.lcu-default-error {
  color: $danger;
}

.lcu-modal-card {
  border: 1px solid $page-border;
  display: grid;
  grid-template-columns: repeat(4, max-content);
  grid-gap: 20px;
  border-radius: 3px;
  padding: 10px;
  align-items: center;
}

.lcu-modal-cardLogo {
  width: 50px;
}

// defaults to open
.lcu-bill-status {
  font-weight: bold;
  padding: 3px 6px 5px;
  color: #2f6290;
  background: #dcf1ff;
  border-radius: 4px;
  font-size: 13px;
}

.lcu-bill-pastdue {
  color: $danger;
  background: #ffe1e1;
}

.lcu-bill-paid {
  color: #1f8142;
  background: #d3fae4;
}
</style>
